import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ValidationCallbackData } from 'devextreme/ui/validation_rules';
import { DxFormModule } from 'devextreme-angular/ui/form';
import { DxLoadIndicatorModule } from 'devextreme-angular/ui/load-indicator';
import notify from 'devextreme/ui/notify';
import { AuthService } from '../../services';
import { TranslateService } from '@ngx-translate/core'; 
import { NotifyService } from 'src/app/shared/services/hr/notify.service';
import { SuperComponent } from 'src/app/pages/super/super.component';
import { ObjectsService } from '../../services/hr/objects.service';
import { genericCustomStoreService } from '../../services/genericCustomStore.service';




@Component({
  selector: 'app-change-passsword-form',
  templateUrl: './change-password-form.component.html'
})
export class ChangePasswordFormComponent extends SuperComponent implements OnInit {
 
  formData: any = {};
  recoveryCode: string = '';

  constructor(private authService: AuthService,
    public NotifyService: NotifyService,
     private router: Router,
      private route: ActivatedRoute
    , translate: TranslateService,
    gt: genericCustomStoreService, Objects: ObjectsService) {

  super(Objects, translate, gt)


   }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.recoveryCode = params.get('recoveryCode') || '';
    });
  }
  
  buttonOptions = {
    text: this.translate.instant('employeeduration.submit'),
    type: 'default',

    useSubmitBehavior: true,
  };
   onSubmit(e: Event) {
    e.preventDefault();
   debugger
 
  let data = this.formData;
  
     this.authService.changepassword(data).subscribe(res => { this.NotifyService.notifyfun('add')})
           sessionStorage.removeItem('token');
        sessionStorage.removeItem('data');
        sessionStorage.removeItem('username')
        this.authService.logOut();

     

  }

  confirmPassword = (e: ValidationCallbackData) => {
    return e.value === this.formData.newPassword;
  }
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DxFormModule,
    DxLoadIndicatorModule
  ],
  declarations: [ ChangePasswordFormComponent ],
  exports: [ ChangePasswordFormComponent ]
})
export class ChangePasswordFormModule { }
